import React from 'react'
import AdminMenuListingComponent from '../../Components/adminMenuListingComponent'
import Aside from '../../Components/aside'
import TopBar from '../../Components/topBar'

const MenuListingPage = () => {
  return (

    <div className="main-wrapper">
      <div className="content-wrapper">
        <AdminMenuListingComponent/>
      </div>
    </div>

  )
}

export default MenuListingPage